import translations from '../../translations.json'
import type { Language } from './format'

type Catalogue = Record<string, string>

export function translationsFor(lang: Language): Catalogue {
  const catalogues = translations as Record<string, Catalogue>
  return catalogues[lang] ?? catalogues.en
}
